// src/browser/serialization.ts
import { Buffer } from "buffer";
import Decimal from "decimal.js-light";
import SuperJSON from "superjson";
SuperJSON.registerCustom(
  {
    isApplicable: (v) => v instanceof Decimal || // interop with decimal.js
    (v == null ? void 0 : v.toStringTag) === "[object Decimal]",
    serialize: (v) => v.toJSON(),
    deserialize: (v) => new Decimal(v)
  },
  "Decimal"
);
SuperJSON.registerCustom(
  {
    isApplicable: (v) => Buffer.isBuffer(v),
    serialize: (v) => v.toString("base64"),
    deserialize: (v) => Buffer.from(v, "base64")
  },
  "Bytes"
);
function serialize(value) {
  const { json, meta } = SuperJSON.serialize(value);
  return { data: json, meta };
}
function deserialize(value, meta) {
  return SuperJSON.deserialize({ json: value, meta });
}
export {
  deserialize,
  serialize
};
//# sourceMappingURL=index.mjs.map